<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4>Importar Productos Centros Consumo</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="validatedCustomFile">Seleccionar archivo Excel (.xlsx)</label>
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="validatedCustomFile" @change="onFileChange" accept=".xlsx">
                                <label class="custom-file-label" for="validatedCustomFile">{{ fileName }}</label>
                            </div>
                        </div>
                        <button class="btn btn-primary mt-3" @click="uploadFile" v-if="!loading">
                            <i class="fa fa-upload"></i> Importar
                        </button>
                        <div v-if="loading" class="spinner-border text-primary mt-3" role="status">
                            <span class="sr-only">Procesando...</span>
                        </div>
                        <div v-if="tiendasNoEncontradas.length > 0" class="alert alert-danger mt-3">
                            <h4>Tiendas no encontradas: {{ tiendasNoEncontradas.length }}</h4>
                            <ul>
                                <li v-for="tienda in tiendasNoEncontradas">{{ tienda }}</li>
                            </ul>
                        </div>
                        <importPtosCC></importPtosCC>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import importPtosCC from "./asignPtosTiendasCC.vue"
export default {
    name: "importPtosCentros",
    components:{
        importPtosCC
    },
    data() {
        return {
            file: null,
            fileName: "Seleccionar archivo...",
            tiendasNoEncontradas: [],
            loading: false
        };
    },
    methods: {
        onFileChange(e) {
            this.file = e.target.files[0];
            this.fileName = this.file ? this.file.name : "Seleccionar archivo...";
        },
        async uploadFile() {
            if (!this.file) return;

            let formData = new FormData();
            formData.append('file', this.file);
            try {
                this.loading = true
                let response = await axios.post('/api/Productos/importPtosCentros', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.data.Success) {
                    this.$swal.fire('Éxito', response.data.Mensaje, 'success');
                    this.file = null
                    this.fileName = "Seleccionar archivo..."
                    document.getElementById('validatedCustomFile').value = null
                    this.tiendasNoEncontradas = response.data.TiendasErrores
                } else {
                    this.$swal.fire('Error', response.data.Mensaje, 'error')
                }
            } catch (error) {
                console.error(error);
                this.$swal.fire('Error', 'Ocurrió un error al subir el archivo.', 'error')
            } finally {
                this.loading = false
            }
        }
    }
}
</script>